import { render, staticRenderFns } from "./SensitivityMatrixCard.vue?vue&type=template&id=2a1b68f6&scoped=true&"
import script from "./SensitivityMatrixCard.vue?vue&type=script&lang=ts&"
export * from "./SensitivityMatrixCard.vue?vue&type=script&lang=ts&"
import style0 from "./SensitivityMatrixCard.vue?vue&type=style&index=0&id=2a1b68f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b68f6",
  null
  
)

export default component.exports